module.exports = __webpack_public_path__ + "static/media/53.7a6169a3.gif";